import VerifyOutDeliveryOrder from "../../../../components/@documents/delivery_orders/VerifyOutDeliveryOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function DeliveryOrderVerifyOutPage() {

    return (
        <VerifyOutDeliveryOrder 
            routeType={routeTypes.workstation}
        />
    )
}